import * as yup from 'yup';

export const validation = (highestDegreeRequired: string) =>
  yup.object().shape({
    activitySpecificFieldAnswers: yup.object().shape({
      relevantDegree: yup.boolean(),
      highestRelevantDegree: yup.string().when('relevantDegree', {
        is: true,
        then: (schema) => schema.required(highestDegreeRequired),
      }),
    }),
  });
